import { apiGET } from './api';

export const getVerificationStatus = ({ entityId, entityType }) =>
  apiGET(`/verifications?entity_id=${entityId}&entity_type=${entityType}`);
